import { usePreferences } from "../../contexts/PreferencesContext";
import React, { useEffect, useRef, useState } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { FaListAlt, FaVideo } from "react-icons/fa";
import { MdDelete, MdModeEdit } from "react-icons/md";
import { Link, useHistory, useParams } from "react-router-dom";
import Search from "../ReusableComponents/Search";

import { Button } from "react-bootstrap";
import Request from "../../Request";
import Pagination from '@material-ui/lab/Pagination';
import { BsFillEyeFill } from "react-icons/bs";
import { logout } from "../../actions/AppActions";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgress } from "@material-ui/core";
import moment from "moment";
import './label.css';


const Redacoes = (props) => {const { t } = usePreferences();

  const [lesson_cards, SetLessonCards] = useState(null);
  const [loading_screen, setLoadingScreen] = useState(true);
  const [loading_redacoes, setLoadingredacoes] = useState(false);
  const [search_oficial, setSearchOficial] = useState('');

  const [redacoes, setredacoes] = useState([]);
  const [pagination, setPagination] = useState({ current_page: 1, last_page: 1 });



  const [search, setSearch] = useState('');
  const { processo_id, processo_name, simulado, has_blocks } = props;
  const [show_warning, setShowWarning] = useState(false);
  const [redacao_id, setRedacaoId] = useState(null);


  const [questaoSelect, setQuestaoSelect] = useState({});

  const [showModal, setShowModal] = useState(false);
  let refs = [];
  const dispatch = useDispatch();

  const Getredacoes = async (page, search) => {

    let response = await Request.Get(`faculdade/get_redacoes/${processo_id}?page=${page}&search=${search}`);
    console.log(response);
    if (response === undefined) return;
    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }
    if (response.pagination.current_page == page) {

      setredacoes(response.redacoes);

      setPagination(response.pagination);
      props.setState({total_essay:response.pagination.total_pages})

      setLoadingScreen(false);
      setLoadingredacoes(false);


    }
  };

  const DeleteRedacao = async (redacao_id) => {

    let response = await Request.Delete(`faculdade/delete_redacao/${redacao_id}`);
    console.log(response);
    if (response === undefined) return;

    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }
    Getredacoes(pagination.current_page, search_oficial);



  };

  useEffect(() => {
    Getredacoes(1, search_oficial);
  }, []);
  const user = useSelector((state) => state.AppReducer.user);

  let pesquisarTimeout = null;
  const history = useHistory();
  return (
    <>


            {/* <hr /> */}
            {loading_screen == false && <div className="module-card-container">

                <div className="module-breadcrumb">

                    <button
            className="breadcrumb-back"
            onClick={() =>
            props.setState({
              activeTab: -1
            })
            }>{t("dashboard")}


          </button>

                    <span>/</span>

                    <strong>{t("essays")}</strong>

                </div>

                <div className="module-title-row">

                    <div>

                        <h3 style={{ fontWeight: 'bold' }}>{t("essays")}</h3>

                        <p>{t("ui_gerencie_as_redacoes_vinculadas_ao_processo_9e0682a4")}

            </p>

                    </div>

                    <button
            className="btn-dashboard-modern"
            onClick={() =>
            props.setState({
              activeTab: -1
            })
            }>{`
                        ${t("legacy_dashboard")}
                    `}
          </button>



                </div>

                {/* <h4 className="mt-0 header-title" style={{ fontSize: '1.2rem', color: 'black', textAlign: 'center' }}>Questões</h4> */}
                {/* <br /> */}

                <div className="module-toolbar">

                    <Search placeholder={t("legacy_pesquisar_pelo_enunciado_ou_nome_da_redacao")} ValueChange={(value) => {
            clearTimeout(pesquisarTimeout);
            setSearchOficial(value);

            pesquisarTimeout = setTimeout(() => {
              let page = { ...pagination };
              page.current_page = 1;
              setPagination(pagination);
              setLoadingredacoes(true);

              Getredacoes(1, value);

            }, 500);
          }} />

          <Link
            to={`/redacoes/register/${processo_id}`}
            className="btn-module-primary">


                            <FaListAlt />{t("ui_nova_redacao_f7f8f71a")}



          </Link>



                </div>

                <div className="table-modern-card">

                    <table id="tech-companies-1" className="table table-striped">
                        <thead>
                            <tr>

                                <th>{t("label_name")}</th>
                                <th>{t("label_statement")}</th>
                                {has_blocks && <th>{t("label_block")}</th>}

                                <th data-priority="3">{t("label_actions")}</th>

                            </tr>
                        </thead>
                        <tbody>
                            {loading_redacoes == false && redacoes.map((item, id) =>

              <tr key={id}>
                                    <td>

                                        <div className="redacao-name">

                                            <strong>
                                                {item.name}
                                            </strong>

                                        </div>

                                    </td>
                                    <td>

                                        <div className="redacao-preview">

                                            {item.enunciado_content.
                    replace(/<[^>]*>?/gm, '').
                    substring(0, 120)}

                                            {item.enunciado_content.length > 120 && '...'}

                                        </div>

                                    </td>
                                    {has_blocks &&
                <td>
                    <span className={`trust-badge ${item.block ? 'trust-low' : 'trust-medium'}`}>
                        {item.block ? item.block.name : t("label_without_block")}
                    </span>
                </td>}
                                    {/* <td><img style={{ height: 60, width: 60, objectFit: 'contain' }} src={STORAGE_URL + STORAGE_URL + item.arquivo} /></td> */}

                                    <td>
                                        <div className="actions-group">

                                            <Link to={`/redacoes/show/${item.id}`}>

                                                <button
                        className="action-btn warning">

                                                    <BsFillEyeFill />
                                                </button>

                                            </Link>

                                            <Link to={`/redacoes/edit/${item.id}`}>

                                                <button
                        className="action-btn info">

                                                    <MdModeEdit />
                                                </button>

                                            </Link>

                                            <button
                      className="action-btn danger"
                      onClick={() => {
                        setRedacaoId(item.id);
                        setShowWarning(true);
                      }}>

                                                <MdDelete />
                                            </button>

                                        </div>
                                    </td>

                                </tr>
              )}

                        </tbody>
                    </table>
                    {loading_redacoes == true &&
          <div className="row" style={{ margin: 0 }}> <div className="col-12 d-flex justify-content-center align-items-center">
                            {/* <div className="spinner-border text-primary" role="status"  >
                </div> */}
                            <CircularProgress />
                        </div></div>

          }
                </div>
                {loading_redacoes == false && redacoes.length == 0 && <div className="empty-module">

                    <div className="empty-module-icon">
                        📝
                    </div>

                    <h3>{`
                        ${t("legacy_nenhuma_redacao_encontrada")}
                    `}</h3>

                    <p>{t("ui_cadastre_a_primeira_redacao_deste_processo_7b43c0f0")}

          </p>



                </div>}

                <Pagination
          className={pagination.last_page == 1 ? "hide" : ""}
          style={{ display: "flex", justifyContent: "flex-end" }}
          count={pagination.last_page}
          value={pagination.current_page}
          onChange={(_, value) => {
            setLoadingredacoes(true);
            console.log(_, value);
            let page = { ...pagination };
            page.current_page = value;
            setPagination(pagination);
            Getredacoes(value, search_oficial);
          }} />


                {/* {this.state.andamento == true && <AvaliacaoAndamento get_redacao={this.get_redacao.bind(this)} {...this.props} />} */}

            </div>}

            {loading_screen == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center" style={{ marginTop: '2rem' }}>
                {/* <div className="spinner-border text-primary" role="status"  >
            </div> */}
                <CircularProgress />
            </div></div>}

            <SweetAlert
        warning
        title={t("legacy_atencao")}
        onConfirm={() => {
          setShowWarning(false);
          setLoadingredacoes(true);
          DeleteRedacao(redacao_id);
          // this.delete_banner(this.state.banner_to_delete);
        }}
        onCancel={() => {
          setShowWarning(false);
        }}
        show={show_warning}
        confirmBtnText={t("legacy_sim_desejo_apagar")}
        cancelBtnText={t("legacy_cancelar")}
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="danger"
        showCancel={true}>{t("ui_ao_deletar_esta_redacao_ele_nao_estara_mais_dispon_1440dab3")}


      </SweetAlert>


        </>);

};

export default Redacoes;
